import React, { createContext, useImperativeHandle, useRef, useState } from 'react'
import BaseModal from '@/component/modal/BaseModal.tsx'
import useQueryGetAlertEmergencyLive, {
    EmergencyAlertType,
    IResGetEmergencyLive
} from '@/api/notification/getLiveEmergencyAlert.ts'
import EmergencyAlertDetail from '@/pages/notification/emergency/EmergencyAlertDetail.tsx'
import { isEmptyArray, isNotEmptyArray } from '@/util/array.ts'
import { useTranslation } from 'react-i18next'
import { IResGetFalldetectionLive } from '@/api/notification/getLiveFalldetectionAlert.ts'


export interface IProps {
    className?: string
    refetchAlerts?: () => void
    defaultId?: number
    defaultTab?: EmergencyAlertType
    sosAlerts?: IResGetEmergencyLive
    fallAlerts?: IResGetFalldetectionLive
    isLiveMode?: boolean
}

export type IEmergencyLiveAlertContextProps = {
    id?: number
    setId: (id: number) => void
    refetchList: () => void
    refetchAndResetSelection: () => void
}

export const EmergencyLiveAlertContext = createContext<IEmergencyLiveAlertContextProps>({
    id: undefined,
    setId: () => {
    },
    refetchList: () => {
    },
    refetchAndResetSelection: () => {
    }
})

const EmergencyAlertModal = ({ defaultId, refetchAlerts, defaultTab: _defaultTab, sosAlerts: _sosAlerts, fallAlerts: _fallAlerts, isLiveMode: _isLiveMode }: IProps, ref: any) => {
    useTranslation()

    const modalRef = useRef<any>()
    const [id, setId] = useState<number>()
    const { data: alerts, refetch: refetchList } = useQueryGetAlertEmergencyLive(true)

    const refetchAndResetSelection = async () => {
        const { data: resAlerts } = await refetchList()
        setId(undefined)

        const newAlerts = resAlerts?.emergencies
        if (isEmptyArray(newAlerts)) {
            modalRef.current.close()
            return
        }

        const myAlerts = newAlerts?.filter(item => item?.alert?.isMyTask == true)
        if (myAlerts && isNotEmptyArray(myAlerts)) {
            setId(myAlerts[0].id)
            return
        }

        const notMyAlerts = newAlerts?.filter(item => !item?.alert?.taskManagerAt)
        if (notMyAlerts && isNotEmptyArray(notMyAlerts)) {
            setId(notMyAlerts[0].id)
            return
        }
    }

    useImperativeHandle(ref, () => ({
        show: () => {
            modalRef.current.show()
        },
        close: () => {
            modalRef.current.close()
        }
    }))

    return (
        <EmergencyLiveAlertContext.Provider value={{ id, setId, refetchList, refetchAndResetSelection }}>
            <BaseModal
                ref={modalRef}
                width={'1200'}
                onOpenCallback={() => {
                    if (id) return
                    if (defaultId) {
                        setId(defaultId)
                    } else if ((alerts?.emergencies?.length || 0) > 0) {
                        setId(alerts?.emergencies[0]!.id)
                    }
                }}
                onCloseCallback={() => {
                    setId(undefined)
                    refetchAlerts && refetchAlerts()
                }}
                showCloseButton={false}>

                <div className={'p-3 sm:p-4 md:p-5 max-h-[90vh] overflow-auto'}>
                    <EmergencyAlertDetail />
                </div>
            </BaseModal>
        </EmergencyLiveAlertContext.Provider>

    )
}

export default React.forwardRef(EmergencyAlertModal)

